export interface IWhatsAppTemplate {
    id: number,
    waChannelId: number,
    accountId: number,
    templateWAId: string,
    name: string,
    categoryId: number,
    languageId: number,
    languageCode: string,
    statusId: number,
    updatedOn?: string,
    qualityScoreId?: number,
    previousCategoryId?: number,
    rejectionReasonId?: number,
    header?: ITemplateHeader,
    body: ITemplateBody,
    footer?: ITemplateFooter,
    buttons?: ITemplateButton[],
    status: ITemplateLookup,
    qualityScore?: ITemplateLookup,
    category: ITemplateLookup,
    language?: ITemplateLookup,
    rejectionReason?: ITemplateLookup,
}

export interface ITemplateCreateData {
    category: number;
    name: string;
    languageCode: string;
    language: string;
    header?: ITemplateHeader | null;
    body: ITemplateBody | null;
    footer: ITemplateFooter | null;
    buttons: ITemplateButton[] | null
}

export interface ITemplateUpdateData extends ITemplateCreateData {
    templateId?: number
}

export interface NewTemplateFormData {
    name: string;
    category: TEMPLATE_CATEGORY;
    languageCode: string;
}

export interface ITemplateBody {
    text?: string | null;
    examples?: string[] | null
    addSecurityRecommendation?: boolean | null
}

export interface ITemplateHeader {
    format?: number | null;
    text?: string | null;
    example?: string | null;
    headerHandle?: string[] | null;
}

export interface ITemplateFooter {
    text?: string | null
    otpExpirationMinutes?: number | null
}

export interface ITemplateButton {
    id: number
    type?: number | null
    text?: string
    otpButtonType?: number | null
    autofillText?: string | null
    packageName?: string | null
    signatureHash?: string | null
    example?: string[] | null
    phoneNumber?: string | null
    url?: string | null,
    // urlType?: number | null
}
export interface ITemplateLookup {
    id: number
    name: string
    code: string
    resourceKey: string
    autofillBtnText?: string
    copyCodeBtnText?: string
    copyOfferCodeBtnText?: string
    bodyText?: string
    securityText?: string
    expirationTextSingular?: string
    expirationTextPlural?: string
}

export interface ITemplatesUsageResult{
    names:string,
    templatesUsagePosition : TEMPLATE_USAGE_POSITIONS
}

export type TemplateListHeaderItem = {
    id: TEMPLATE_SORT
    label: string
    sortable?: boolean
}

export type TemplateListFilter = {
    searchQuery?: string
    categoryId?: number
    languageId?: number
    statusId?: number
}

export type TextStyleType = 'BOLD' | 'ITALIC' | 'STRIKETHROUGHT' | 'MONOSPACE'

export type TemplateFormModeType = 'NEW' | 'EDIT'

export enum TEMPLATE_CATEGORY {
    MARKETING = 1,
    UTILITY = 2,
    AUTHENTICATION = 3,
}

export enum TEMPLATE_STATUS {
    APPROVED = 1,
    IN_APPEAL = 2,
    PENDING = 3,
    REJECTED = 4,
    PENDING_DELETION = 5,
    DELETED = 6,
    DISABLED = 7,
    PAUSED = 8,
    LIMIT_EXCEEDED = 9,
}

export enum QUALITY_SCORE {
    GREEN = 1,
    YELLOW = 2,
    RED = 3,
    UNKNOWN = 4,
}

export enum TEMPLATE_SORT {
    NAME = 'name',
    LANGUAGE = 'languageId',
    STATUS = 'statusId',
    LAST_UPDATED = 'updatedOn',
}

export enum TEMPLATE_HEADER_FORMAT {
    TEXT = 0,
    MEDIA = 1,
    VIDEO = 2,
    IMAGE = 3,
    LOCATION = 4,
    DOCUMENT = 5,
    NONE = -1,
}

export enum TEMPLATE_BUTTON_TYPE {
    PHONE_NUMBER = 0,
    URL = 1,
    QUICK_REPLY = 2,
    OTP = 3,
    COPY_OFFER = 4,
}

export enum OTP_BUTTON_TYPE {
    COPY = 0,
    ONE_TAB = 1
}

export enum TEMPLATE_BUTTON_URL_TYPE {
    STATIC = 1,
    DYNAMIC = 2,
}

export enum TEMPLATE_USAGE_POSITIONS {
    CAMPAIGN = 1,
    SALLA = 2,
    ZID = 3,
}